// Distritos/regiões de Portugal para páginas SEO por localização.
export const DISTRICTS = [
  { slug: 'lisboa', label: 'Lisboa' },
  { slug: 'porto', label: 'Porto' },
  { slug: 'braga', label: 'Braga' },
  { slug: 'aveiro', label: 'Aveiro' },
  { slug: 'coimbra', label: 'Coimbra' },
  { slug: 'faro', label: 'Faro' },
  { slug: 'setubal', label: 'Setúbal' },
  { slug: 'leiria', label: 'Leiria' },
  { slug: 'viseu', label: 'Viseu' },
  { slug: 'santarem', label: 'Santarém' },
  { slug: 'evora', label: 'Évora' },
  { slug: 'beja', label: 'Beja' },
  { slug: 'guarda', label: 'Guarda' },
  { slug: 'viana-do-castelo', label: 'Viana do Castelo' },
  { slug: 'vila-real', label: 'Vila Real' },
  { slug: 'braganca', label: 'Bragança' },
  { slug: 'castelo-branco', label: 'Castelo Branco' },
  { slug: 'portalegre', label: 'Portalegre' },
  { slug: 'funchal', label: 'Funchal' },
  { slug: 'ponta-delgada', label: 'Ponta Delgada' },
];

export const DISTRICT_MAP = DISTRICTS.reduce((acc, d) => {
  acc[d.slug] = d.label;
  return acc;
}, {});
